export default "__VITE_ASSET__Dc72UJYi__"